import gql from "graphql-tag";

export const CREATE_REGIME = gql`
  mutation AddRegime($data: RegimeDataInput) {
    addRegime(data: $data) {
      id
      name
      code
      order
    }
  }
`;

export const UPDATE_REGIME = gql`
  mutation UpdateRegime($where: RegimeWhereInput, $data: RegimeDataInput) {
    updateRegime(where: $where, data: $data) {
      id
      name
      code
      order
    }
  }
`;

export const DELETE_REGIME = gql`
  mutation DeleteRegime($where: RegimeWhereInput) {
    deleteRegime(where: $where) {
      id
    }
  }
`;

const regimes = { CREATE_REGIME, UPDATE_REGIME, DELETE_REGIME };

export default regimes;
